import type { ComponentPropsWithRef } from 'react'

export interface ProgressBarProps extends ComponentPropsWithRef<'div'> {
    percentage: number
}

export function ProgressBar({
    percentage,
    className = '',
    ...restProps
}: ProgressBarProps) {
    const clampedPercentage = Math.min(100, Math.max(0, percentage))

    return (
        <div
            role="progressbar"
            aria-valuenow={clampedPercentage}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={restProps['aria-label'] ?? 'Progress'}
            {...restProps}
            className={`flex w-full h-4 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700 ${className}`.trim()}
        >
            <div
                className="flex flex-col justify-center overflow-hidden bg-primary text-xs text-white text-center transition-all duration-300"
                style={{ width: `${clampedPercentage}%` }}
            >
                {clampedPercentage}%
            </div>
        </div>
    )
}
